<template>
  <div>
    <Head title="Dashboard" />
    <div v-if="info" class="top-1/2 left-1/2 h-screen transform flex items-center justify-center mx-2 -translate-x-1/2 fixed -translate-y-1/2 bg-orfBlue-100 w-full z-50 bg-opacity-30" @click="info = null">
      <div class="flex flex-col p-4 w-72 sm:w-96 bg-white relative">
        <HeroIcon name="close" class="w-8 h-8 absolute -top-3 -right-3 z-40 cursor-pointer fill-orfBlue-100 bg-white rounded-full transform hover:scale-125 transition"/>
        <div class="absolute top-7 right-7 font-bold capitalize flex items-center text-lg" :class="'text-' + info.type + '-100'">
          <HeroIcon :name="info.type" class="w-6 h-6 mr-1" :class="'fill-' + info.type + '-100'"/>
          {{info.type}}
        </div>
        <h2 class="font-bold text-xl">
          {{ info.user.first_name }} {{info.user.last_name}}
        </h2>
        <div class="font-bold text-sm">{{this.formatDateTime(info.start, 'LL')}}</div>
        <div class="mt-4 flex flex-col">
          <span class="font-bold mb-1">Beschreibung:</span>
          {{info.description}}
        </div>
      </div>
    </div>

    <div class="relative max-w-full">

      <div class="flex flex-col items-center justify-between mb-6 lg:flex-row text-3xl" style="max-width: 1200px;">
        <loading-button v-if="dashboard" text="Mein Kalender" :inverted="true" icon-name="calendar" func="link" :href="'/users/' + auth.user.id" class="mb-4 sm:mb-0 sm:mr-4"/>
        <loading-button v-else text="Dashboard" :inverted="true" icon-name="arrow-left" func="link" href="/" class="mb-4 sm:mb-0 sm:mr-4"/>
        <div class="flex-grow">
          <Search v-if="dashboard" href="/" :users="users" :filters="dashboard" :auth="auth" />
          <div v-else-if="department && user" class="flex items-center font-bold text-orfBlue-100">
            <HeroIcon name="user-circle" mini class="mr-2 h-8 w-8 fill-orfBlue-100" />
            <div class="mt-1">{{user.first_name}} {{user.last_name}}</div>
          </div>
          <div v-else-if="department" class="flex items-center font-bold text-orfBlue-100">
            <HeroIcon name="flag" class="mr-2 h-8 w-8 fill-orfBlue-100" />
            <div class="mt-1">{{department.name}}</div>
          </div>
        </div>
        <div class="flex flex-row flex-wrap mx-1 items-center">
          <div class="flex flex-grow md:flex-row flex-wrap justify-center mx-1 my-3 lg:my-0">
            <div v-for="type in visibleTypesNames" @click="toggleVisibleTypes(type)" :key="type" :class="['my-1 cursor-pointer items-center shadow-md bg-white capitalize text-xs mx-1 flex p-1 rounded border']" :style="['border-color: ' + (type == 'urlaub' ? '#F1C40F' : type == 'homeoffice' ? '#27AE60' : '#3498DB'), 'color: ' + (type == 'urlaub' ? '#F1C40F' : type == 'homeoffice' ? '#27AE60' : '#3498DB'), 'opacity: ' + (visibleStatusTypes[type] ? '1' : '0.5')]">
              <svg v-if="visibleStatusTypes[type]" xmlns="http://www.w3.org/2000/svg" class="mr-1 w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
              </svg>
              <svg v-if="!visibleStatusTypes[type]" xmlns="http://www.w3.org/2000/svg" class="mr-1 w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd" />
                <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
              </svg>
              <HeroIcon :name="type" class="mr-1 w-3 h-3 md:w-4 md:h-4" :fill="type == 'urlaub' ? '#F1C40F' : type == 'homeoffice' ? '#27AE60' : '#3498DB'" />
              {{ type }}
            </div>
          </div>
          <!--          <div class="flex justify-between md:w-auto items-center">
                      <button :class="[' flex p-2 group ml-2 flex-row items-center w-auto h-8 transform hover:scale-105 text-orfBlue-100 font-bold text-xs']" @click="toggleSettingsOpen">
                        <HeroIcon name="settings" class="mr-1 w-3 h-3 fill-orfBlue-100 md:w-4 md:h-4" />
                        Farben
                        <HeroIcon :name="settingsOpen ? 'cheveron-up' : 'cheveron-down'" class="mr-1 w-3 h-3 fill-orfBlue-100 md:w-4 md:h-4" fill="orfBlue-100" />
                      </button>
                    </div>-->
        </div>
      </div>
      <div v-if="settingsOpen" class="flex flex-col md:flex-row items-center justify-center md:justify-between my-2">
        <div class="flex justify-center flex-wrap">
          <div v-for="user in Object.values(teams).find(x => x.id == team).users" :key="user.id" :class="['flex my-1 whitespace-nowrap relative cursor-pointer items-center shadow-md bg-white capitalize text-xs mx-1 flex p-1 rounded border']" :style="['border-color: ' + (auth.user.id == user.id ? (userColors && userColors[user.id] ? userColors[user.id] : user.color) : 'transparent'), 'color: ' + (userColors && userColors[user.id] ? userColors[user.id] : user.color), 'background: ' + hexToRgbA((userColors && userColors[user.id] ? userColors[user.id] : user.color))]">
            <input :id="user.id" :value="userColors && userColors[user.id] ? userColors[user.id] : user.color" @change="changeUserColor" type="color" :style="['background: ' + (userColors && userColors[user.id] ? userColors[user.id] : user.color)]" class="w-4 h-4 mr-2 rounded-full shadow-2xl cursor-pointer" />
            <label :for="user.id" class="cursor-pointer">
              {{ user.first_name + ' ' + user.last_name.charAt(0) + '.' }}
            </label>
          </div>
        </div>
        <loading-button :loading="form.processing" :class="['btn-orfBlue mt-2 mr-1 md:mt-0 p-2 group flex flex-row items-center w-auto h-8 text-xs']" type="submit" @click="updateColors">
          <HeroIcon name="check" class="mr-1 w-3 h-3 group-hover:fill-orfBlue-100 md:w-4 md:h-4" fill="white" />
          Speichern
        </loading-button>
      </div>
      <div class="flex mt-6">
        <div v-if="!userSearch" class="w-full flex shadow-inner" style="max-width: 1200px">
          <div class="w-20 cursor-pointer p-2 flex-grow text-center border relative border-gray-100 border-opacity-30 text-xs md:text-normal hover:font-bold" :class="{'border-gray-700 border-b-0 font-bold' : selectedTeam == 1}"  @click="selectedTeam=1">
            <div v-if="selectedTeam == 1" class="absolute -bottom-0.5 bg-gray-100 z-30 left-0 h-0.5 w-full"></div>
            Alle
          </div>
          <div v-for="team in teams" :key="team.id" class="w-20 cursor-pointer p-2 flex-grow text-center border relative border-gray-100 border-opacity-30 text-xs md:text-normal hover:font-bold" :class="{'border-gray-700 border-b-0 font-bold' : selectedTeam == team.id, 'hidden' : team.id == 1 }"  @click="selectedTeam=team.id">
            <div v-if="selectedTeam == team.id" class="absolute -bottom-0.5 bg-gray-100 z-30 left-0 h-0.5 w-full"></div>
            {{team.name}}
          </div>
        </div>
        <div v-if="userSearch" class="w-full flex py-1 items-center justify-center shadow-inner" style="max-width: 1200px">
          <div class="mx-2 text-orfBlue-100 text-xl">{{ userSearch.first_name }} {{ userSearch.last_name }}</div>
          <div class="mx-2 text-sm" :style="['color: ' + userSearch.team.color]">{{ userSearch.team.name }}</div>
        </div>
        <div class="lg:w-96 lg:max-w-xs">
        </div>
      </div>

      <div class="flex flex-col-reverse w-full xxs:shadow-inner lg:flex-row-reverse">
        <div class="flex flex-col w-full border border-b-0 border-gray-300 lg:w-128  lg:border-b">
          <div class="relative flex items-center justify-between px-1 py-3 border-b border-gray-200">
            <div @click="navigate(false)" class="group mx-1 hover:bg-orfBlue-100 rounded cursor-pointer">
              <HeroIcon name="cheveron-left" class="block w-6 h-6 fill-gray-500 group-hover:fill-white" />
            </div>
            <div class="flex items-center hover:text-orfBlue-100 font-bold cursor-pointer" @click="openDatePicker = !openDatePicker">
              <svg xmlns="http://www.w3.org/2000/?svg" class="mr-1 w-4 h-4 fill-orfBlue-100" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
              </svg>
              {{ formatDateTime(selectedDay, 'dddd D. MMM') }}
              <DatePicker v-if="openDatePicker" mode="date" locale="de" v-model="selectedDay" class="custom-picker z-50 left-1/2 top-10 w-auto h-auto transform -translate-x-1/2" />
            </div>
            <div @click="navigate(true)" class="group mx-1 hover:bg-orfBlue-100 rounded cursor-pointer">
              <HeroIcon name="cheveron-right" class="block w-6 h-6 fill-gray-500 group-hover:fill-white" />
            </div>
          </div>
          <div class="flex justify-center p-3 text-sm border-b border-gray-400 shadow-inner">
            <div class="max-w-sm">
              <h1 class="mb-2 text-center text-orfBlue-100 font-bold">Neuer Termin</h1>
              <form @submit.prevent="store" class="flex flex-col items-center">
                <select-input v-model="form.type" :pre="form.type ? form.type : 'büro'" :error="form.errors.type" class="flex items-center justify-between my-2 w-40 w-full font-bold" label="Art">
                  <option value="büro">Büro</option>
                  <option hidden value="homeoffice">Homeoffice</option>
                  <option value="urlaub">Urlaub</option>
                </select-input>
                <div v-if="form.type == 'urlaub'" class="flex items-center justify-between w-full max-w-xs">
                  <DatePicker locale="de" class="flex flex-wrap" mode="date" :popover="{ visibility: 'focus', placement: 'bottom' }" v-model="form.startDate" is24hr :minute-increment="15">
                    <template v-slot="{ inputValue, inputEvents }">
                      <div class="w-full">
                        <div class="flex items-center justify-between">
                          <label class="form-label flex-grow mb-0 font-bold" for="startDate">Von</label>
                          <input id="startDate" class="form-input ml-2 w-28" :value="inputValue" v-on="inputEvents" />
                        </div>
                        <div v-if="form.errors.start" class="form-error">{{ form.error.start }}</div>
                      </div>
                    </template>
                  </DatePicker>
                  <DatePicker locale="de" class="flex flex-wrap ml-2" mode="date" :popover="{ visibility: 'focus', placement: 'bottom' }" v-model="form.endDate" is24hr :minute-increment="15">
                    <template v-slot="{ inputValue, inputEvents }">
                      <div class="w-full">
                        <div class="flex items-center justify-between">
                          <label class="form-label flex-grow mb-0 font-bold" for="endDate">Bis</label>
                          <input id="endDate" class="form-input ml-2 w-28" :value="inputValue" v-on="inputEvents" />
                        </div>
                        <div v-if="form.errors.end" class="form-error">{{ form.errors.end }}</div>
                      </div>
                    </template>
                  </DatePicker>
                </div>
                <div v-if="false" class="flex items-center justify-between w-full max-w-xs">
                  <DatePicker class="flex flex-wrap" mode="time" :popover="{ visibility: 'focus', placement: 'bottom' }" v-model="form.start" is24hr :minute-increment="15">
                    <template v-slot="{ inputValue, inputEvents }">
                      <div class="w-full">
                        <div class="flex items-center justify-between">
                          <label class="form-label flex-grow mb-0 font-bold" for="start">Von</label>
                          <input id="start" class="form-input ml-2 w-20" :value="inputValue" v-on="inputEvents" />
                        </div>
                        <div v-if="form.errors.start" class="form-error">{{ form.error.start }}</div>
                      </div>
                    </template>
                  </DatePicker>
                  <DatePicker class="flex flex-wrap ml-2" mode="time" :popover="{ visibility: 'focus', placement: 'bottom' }" v-model="form.end" is24hr :minute-increment="15">
                    <template v-slot="{ inputValue, inputEvents }">
                      <div class="w-full">
                        <div class="flex items-center justify-between">
                          <label class="form-label flex-grow mb-0 font-bold" for="end">Bis</label>
                          <input id="end" class="form-input ml-2 w-20" :value="inputValue" v-on="inputEvents" />
                        </div>
                        <div v-if="form.errors.end" class="form-error">{{ form.errors.end }}</div>
                      </div>
                    </template>
                  </DatePicker>
                </div>
                <div class="flex flex-wrap justify-center my-1 w-full max-w-xs text-center">
                  <textarea-input v-model="form.description" :error="form.errors.description" class="w-full" placeholder="Beschreibung (optional)" />
                </div>
                <div class="flex items-center justify-center px-8 py-4 border-t border-gray-100">
                  <loading-button text="Termin erstellen" icon-name="save" icon-custom-icon/>
                </div>
              </form>
              <div v-for="errors in form.errors">{{ errors }}</div>
            </div>
          </div>
          <div class="overflow-y-auto flex-grow" v-if="groupedSelectedDayEvents && !userSearch">
            <div v-if="selectedTeam == 1" class="flex items-center shadow-md p-4 text-center justify-center font-bold text-orfBlue-100">
              Im Büro: ( <div class="mx-1" :class="(today_count >= 0 && today_count < 12 ) ? ( today_count < 6 ? 'text-green-500' : 'text-yellow-500' ) : 'text-orfRed-100'">{{today_count}}</div> / 12 )
            </div>
            <div v-else class="flex items-center shadow-md p-4 text-center justify-center font-bold text-orfBlue-100">
              {{getTeamData(selectedTeam, 'name')}} im Büro: ( {{today_count}} )
              <loading-button text="Alle Teams" icon-name="search" icon-custom-icon class="ml-auto" small inverted @click.prevent="selectedTeam=1"/>
            </div>
            <div class="p-4">
              <template v-for="(data,type) in groupedSelectedDayEvents" :key="type">
                <div v-if="selectedTeam == getTeamId(type)" class="flex flex-col py-2">
                  <div v-if="selectedTeam == 1" class="font-bold text-sm text-center mb-2 border-b-2">
                    {{type}} ( {{data.length}} )
                  </div>
                  <div v-for="(event, idx) in data" :key="idx" class="flex items-center py-1">
                    <div class="flex-grow">
                        {{ event.customData.user.first_name }} {{event.customData.user.last_name}}
                    </div>
                    <div class="w-28 font-bold capitalize flex items-center" :class="'text-' + type + '-100'">
                      <HeroIcon :name="type" class="w-4 h-4 mr-1" :class="'fill-' + type + '-100'"/>
                      {{type}}
                    </div>
                  </div>
                </div>
                <div v-else class="flex flex-col py-2">
                  <div v-if="selectedTeam == 1" class="font-bold text-sm text-center mb-2 border-b-2">
                    {{type}} ( {{data.length}} )
                  </div>
                  <div v-for="(event, idx) in data" :key="idx" class="flex items-center py-1">
                    <div class="flex-grow">
                        {{ event.customData.user.first_name }} {{event.customData.user.last_name}}
                    </div>
                    <div class="w-28 font-bold capitalize flex items-center" :class="'text-' + type + '-100'">
                      <HeroIcon :name="type" class="w-4 h-4 mr-1" :class="'fill-' + type + '-100'"/>
                      {{type}}
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="relative w-full" style="max-width: 1200px">
          <Calendar class="custom-calendar relative" is-range :attributes="events" @update:toPage="getEvents" locale="de" trim-weeks >
            <template v-slot:day-content="{ day, attributes }">
              <div class="group relative z-10 flex flex-col h-full">
                <div :class="['absolute left-0 top-0 group-hover:flex w-full h-full bg-orfBlue-100 bg-opacity-10 cursor-pointer', this.formatDateTime(selectedDay, 'LL') == this.formatDateTime(day.date, 'LL') ? 'flex' : 'hidden']" @click="navigate(null, day.date)"></div>
                <span class="day-label flex items-center justify-between h-6 text-gray-900 text-xs"
                  ><div>{{ day.day }}</div>
                  <div v-if="this.formatDateTime(day.date, 'LL') == this.formatDateTime(Date.now(), 'LL')" class="flex items-center justify-between">
                    <div class="hidden text-orfBlue-100 font-bold sm:flex">Heute</div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" :class="['w-4 h-4 fill-orfBlue-100', this.formatDateTime(selectedDay, 'LL') == this.formatDateTime(day.date, 'LL') ? 'visible' : 'invisible']" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
                  </svg>
                </span>
                <div class="flex-grow">
                  <Link v-for="attr in attributes" :key="attr.key" :href="`/users/${attr.customData.user.id}`" class="transition transform hover:scale-105" :class="[isVisibleType(attr.customData.type) ? 'flex' : 'hidden', auth.user.id == attr.customData.user.id ? 'cursor-pointer z-50 transition transform hover:scale-105' : '', 'whitespace-nowrap test shadow justify-between items-center w-full relative mb-1 mt-0 p-0.25 xxs:p-1 md:p-1 text-xxs sm:text-xs event leading-tight border font-bold rounded-sm']" :style="['border-color: ' + (auth.user.id == attr.customData.user.id ? attr.customData.color : 'transparent'), 'color: ' + (attr.customData.color), 'background: ' + hexToRgbA(attr.customData.color, '0.1')]" @click="edit(attr.key, attr.customData.user.id)">
                    <HeroIcon :name="attr.customData.type" class="hidden sm:flex mr-0.5 md:mr-1 w-4 h-4 xxs:mr-1 xxs:w-3 xxs:h-3 md:w-5 md:h-5" :fill="attr.customData.type == 'urlaub' ? '#F1C40F' : attr.customData.type == 'homeoffice' ? '#27AE60' : '#3498DB'" />
                    <div :class="['overflow-hidden capitalize w-full overflow-ellipsis', auth.user.id == attr.customData.user.id ? 'z-50 bg-red hover:test-orange-500' : '']">{{userSearch ? attr.customData.type : attr.customData.user.first_name + " " + attr.customData.user.last_name.charAt(0) + "." }}  {{attr.customData.user.department_id}}</div>
                    <div v-if="attr.customData.description && auth.user.id != attr.customData.user.id" class="relative z-50 w-5 md:w-10 flex justify-end h-5 group-second" @click.prevent="() => setInfo(attr)">
                      <HeroIcon name="info" class="w-3 h-3 transform hover:scale-125 transition ease-in-out md:w-5 md:h-5"/>
                    </div>
                    <HeroIcon v-if="auth.user.id == attr.customData.user.id" name="pencil-square" icon-mini class="hidden sm:flex z-50 float-right w-3 h-3 transform hover:scale-125 transition ease-in-out md:w-5 md:h-5" />
                  </Link>
                </div>
              </div>
            </template>
          </Calendar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import moment from 'moment'
import HeroIcon from '@/Shared/HeroIcon.vue'
import Search from '@/Shared/Search'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import Badge from "@/Shared/Badge.vue";

export default {
  components: {
    Badge,
    Search,
    TextareaInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    HeroIcon,
  },
  props: {
    events: Object,
    // eventsGroupedByTeam: Object,
    teams: Array,
    auth: Object,
    filters: Object,
    userSearch: Object,
    users: Array,
    team: Number,
    month: Number,
    userColors: Object,
    dashboard: Boolean,
    department: Object,
    user: Object,
  },
  layout: Layout,
  data() {
    let date = new Date ();
    console.log(this.events, this.teams)
    return {
      formUserColors: {},
      info: null,
      today_count: 0,
      settingsOpen: false,
      currentMonth: parseInt(this.month),
      eventsCopy: this.events,
      openDatePicker: false,
      selectedDay: new Date(),
      selectedTeam: this.team,
      selectedMode: 'büro',
      groupedSelectedDayEvents: null,
      textLight: '#fff',
      textDark: '#000',
      visibleStatus: {},
      visibleStatusTypes: {
        urlaub: this.userSearch ? true : false,
        homeoffice: true,
        büro: true,
      },
      visibleTypesNames: ['büro','urlaub'],
      extendDescription: null,
      form: this.$inertia.form({
        description: null,
        start: new Date(),
        end: new Date(),
        startDate: new Date(),
        endDate: new Date(),
        type: 'büro',
        redirectBack: true,
      }),
      masks: {
        weekdays: 'WWW',
      },
      open: false,
      openData: null,
    }
  },
  computed: {},
  watch: {
    selectedTeam: {
      deep: true,
      handler: throttle(function () {
        let data = {
          'teamId': this.selectedTeam
        }
        this.$inertia.reload({only: ['team', 'teams', 'events'], data: pickBy(data), preserveState: true, onSuccess: () => this.setGroupedSelectedDayEvents(), progress: false});
      }, 250)
    },
    selectedDay: {
      deep: true,
      handler: throttle(function () {
          this.setGroupedSelectedDayEvents();
      }, 250)
    },
  },
  mounted() {
    let visible = {}
    this.eventsCopy.map((e) => {
      visible[e.customData.team_id] = this.userSearch || e.customData.team_id == this.auth.user.team.id
    })
    this.visibleStatus = visible;
    this.setGroupedSelectedDayEvents();
  },
  methods: {
    getTeamColor(name){
      let color = ''
      this.teams.map((team) => {
        if (team.name == name){
          color = team.color
        }
      })
      return color
    },
    getTeamId(name){
      let id = null
      this.teams.map((team) => {
        if (team.name == name){
          id = team.id
        }
      })
      return id
    },
    getTeamData(id, search){
      let data = null
      this.teams.map((team) => {
        if (team.id == id){
          data = team[search]
        }
      })
      return data
    },
    setGroupedSelectedDayEventsOld(){
      this.groupedSelectedDayEvents = null;
      let selectedDayData = {
        büro: [],
        homeoffice: [],
        urlaub: [],
      };
      this.events.map((event) => {
        if (this.formatDateTime(event.customData.start, 'YYYY-MM-DD') == this.formatDateTime(this.selectedDay, 'YYYY-MM-DD')){
          selectedDayData[event.customData.type].push(event);
        } else if (this.formatDateTime(event.customData.end, 'YYYY-MM-DD') == this.formatDateTime(this.selectedDay, 'YYYY-MM-DD')){

          selectedDayData[event.customData.type].push(event);
        }
      })
      this.groupedSelectedDayEvents = selectedDayData
    },
    setGroupedSelectedDayEvents(){
      this.today_count = 0;
      this.groupedSelectedDayEvents = null;
      let selectedDayData = {};
      this.teams.map((team) => {
        selectedDayData[team.name] = []
      })
      this.events.map((event) => {
        if (event.customData.type != 'urlaub'){
          if (this.formatDateTime(event.customData.start, 'YYYY-MM-DD') == this.formatDateTime(this.selectedDay, 'YYYY-MM-DD')){
            this.today_count++;
            selectedDayData[event.customData.team.name].push(event);
          } else if (this.formatDateTime(event.customData.end, 'YYYY-MM-DD') == this.formatDateTime(this.selectedDay, 'YYYY-MM-DD')){
            this.today_count++;
            selectedDayData[event.customData.team.name].push(event);
          }
        }
      })
      this.groupedSelectedDayEvents = selectedDayData
    },
    getEvents(e) {
      if (this.currentMonth != e.month){
        this.$inertia.reload({only:['events', 'month'], data: {'month': e.month}, onSuccess: (data) => {console.log("success", this.events.length); this.currentMonth = e.month}})
      }
    },
    setInfo(attr){
      this.info = attr.customData
    },
    toggleSettingsOpen() {
      this.settingsOpen = !this.settingsOpen;
    },
    hexToRgbA(hex, op = '01') {
      let c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + (op ? op : '0.1)')
      }
      throw new Error('Bad Hex')
    },
    textColor(bg) {
      let hex = bg.charAt(0) === '#' ? bg.substring(1, 7) : bg
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
      }
      if (hex.length !== 6) {
        throw new Error('Invalid HEX color.')
      }
      let r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16)
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? this.textDark : this.textLight
    },
    isVisibleType(value) {
      return this.visibleStatusTypes[value]
    },
    edit(id, userId) {
      if (userId == this.auth.user.id){
        this.$inertia.visit('events/' + id + '/edit')
      }
    },
    navigate(value, customDate) {
      if (value === null && customDate) {
        this.selectedDay = new Date(customDate)
        this.form.start = new Date(customDate)
        this.form.startDate = new Date(customDate)
        this.form.end = new Date(customDate)
        this.form.endDate = new Date(customDate)
      } else {
        var date = new Date(this.selectedDay)
        let newdate = value ? date.setDate(date.getDate() + 1) : date.setDate(date.getDate() - 1)
        this.selectedDay = new Date(newdate)
        var formDate = new Date(this.form.start)
        let newFormdate = value ? formDate.setDate(formDate.getDate() + 1) : formDate.setDate(formDate.getDate() - 1)
        this.form.startDate = new Date(newFormdate)
        this.form.endDate = new Date(newFormdate)
        this.form.start = new Date(newFormdate)
        this.form.end = new Date(newFormdate)
      }
    },
    toggleVisible(id) {
      this.visibleStatus[id] = !this.visibleStatus[id]
    },
    toggleVisibleTypes(value) {
      this.visibleStatusTypes[value] = !this.visibleStatusTypes[value]
    },
    store() {
      this.form.post('/events')
      this.open = false
      this.openData = null
    },
    openPopup(day) {
      console.log(day)
      this.form.start = day.date
      this.open = true
      this.openData = day
    },
    formatDateTime: function (date, format) {
      return moment(date).format(format)
    },
    closePopup(e) {
      if ((e.target && e.target.id == 'container') || e == true) {
        this.open = false
        this.openData = null
      }
    },
    changeUserColor(e){
      this.formUserColors[e.target.id] = e.target.value
    },
    updateColors() {
      this.$inertia.put('userColors', this.formUserColors)
      setTimeout(() => {
        this.settingsOpen = false
      }, 800)
    },
  },
}
</script>

<style>
.custom-picker.vc-container {
  position: absolute;
}
/* +++++++ Hide Weekends +++++++++ */
.custom-calendar.vc-container .vc-day.weekday-7, .custom-calendar.vc-container .vc-day.weekday-1{
  display: none;
}

.custom-calendar .vc-weeks {
  grid-template-columns: repeat(5, 1fr);
}

.custom-calendar .vc-weeks .vc-weekday:nth-child(6),
.custom-calendar .vc-weeks .vc-weekday:nth-child(7) {
  display: none;
}
/* +++++ End Hide Weekends +++++ */

.custom-calendar.vc-container {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 100%;
  --day-height: 100%;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;
  border-radius: 0;
  width: 100%;
}
.custom-calendar.vc-container .vc-header {
  background-color: #f1f5f8;
  padding: 10px 0;
}
.custom-calendar.vc-container .vc-weeks {
  padding: 0;
}
.custom-calendar.vc-container .vc-weekday {
  background-color: var(--weekday-bg);
  border-bottom: var(--weekday-border);
  border-top: var(--weekday-border);
  padding: 3px 0;
}
.custom-calendar.vc-container .vc-day {
  padding: 0 3px 3px 3px;
  overflow: hidden;
  text-align: left;
  max-height: var(--day-height);
  max-width: var(--day-width);
  min-height: 70px;
  background-color: white;
}
.custom-calendar.vc-container .vc-day.weekday-7,
.custom-calendar.vc-container .vc-day.weekday-1 {
  background-color: #eff8ff;
}
.custom-calendar.vc-container .vc-day:not(.on-bottom) {
  border-bottom: var(--day-border);
}
.custom-calendar.vc-container .vc-day:not(.on-bottom).weekday-1 {
  border-bottom: var(--day-border-highlight);
}
.custom-calendar.vc-container .vc-day:not(.on-right) {
  border-right: var(--day-border);
}
.custom-calendar.vc-container .vc-day-dots {
  margin-bottom: 5px;
}
.custom-calendar .vc-arrow:hover > svg {
  background: #000e78;
  color: white;
}
.custom-calendar .vc-arrow > svg {
  width: 24px;
  stroke-width: 1px;
  height: 24px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.eventPopover::after {
  position: absolute;
  top: -2px;
  left: 10px;
  transform: rotate(180deg) translateY(50%);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #1e293c;
  content: ' ';
  font-size: 0;
  line-height: 0;
  margin-left: -5px;
  width: 0;
}
</style>
